document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded',()=>{
  const menu=document.querySelector('[data-menu-button]');
  const nav=document.querySelector('[data-nav]');
  if(menu&&nav){menu.addEventListener('click',()=>{const open=nav.classList.toggle('is-open');menu.setAttribute('aria-expanded',String(open));});}
  const form=document.querySelector('[data-product-form]');
  const variantData=document.querySelector('[data-product-variants]');
  const gallery=document.querySelector('[data-product-gallery]');
  if(form&&variantData){
    const variants=JSON.parse(variantData.textContent);
    form.addEventListener('change',()=>{
      const selected=[...form.querySelectorAll('select[name^="options"]')].map(select=>select.value);
      const variant=variants.find(item=>item.options.every((value,index)=>value===selected[index]));
      if(!variant)return;
      form.querySelector('[data-variant-id]').value=variant.id;
      const submit=form.querySelector('[name="add"]');
      submit.disabled=!variant.available;
      if(gallery&&variant.featuredMediaId){
        const target=[...gallery.querySelectorAll('[data-media-id]')].find(item=>item.dataset.mediaId===String(variant.featuredMediaId));
        if(target){gallery.prepend(target);gallery.scrollTo({left:0,behavior:'smooth'});target.animate([{opacity:.45,transform:'scale(.985)'},{opacity:1,transform:'scale(1)'}],{duration:320,easing:'ease-out'});}
      }
    });
  }
  const items=document.querySelectorAll('.reveal');
  if(!('IntersectionObserver'in window)){items.forEach(item=>item.classList.add('is-visible'));return;}
  const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target);}});},{threshold:.12});
  items.forEach(item=>observer.observe(item));
});
